import React from "react";

import cx from "classnames";

import styles from "./Header.scss";

/**
 * @typedef {object} HeaderProps
 * @prop {ReactElement | string} children
 * @prop {"1" | "2" | "3" | "4" | "5" | "6"} level - H tag level: i.e. h1, h2, etc...
 * @prop {string} [className=""]
 * @prop {string} [size="extraLarge"]
 * @prop {Boolean} [thick=false]
 * @prop {Boolean} [ellipsisOverflow=false]
 */

/**
 * @deprecated talk with the design team about what you want to implement.
 *  Normally, sizes h1 to h3 should be replaced by the `<Heading>` component,
 *  but it can be that the Header component was misused, and it needs to be replaced by something else.
 *  Every other size should be replaced by something that the design team will provide.
 * @param {HeaderProps & Object<string,any>} props
 */
function Header({
  children,
  level,
  className = "",
  size = "extraLarge",
  thick = false,
  ellipsisOverflow = false,
  wrap = false,
  ...props
}) {
  const HeaderTag = `h${level}`;

  const classNames = cx(
    styles["header"],
    {
      [styles["header--wrap"]]: wrap,
      [styles["header--ellipsis-overflow"]]: ellipsisOverflow,
      [styles["header--extra-small"]]: size === Header.SIZES.EXTRA_SMALL,
      [styles["header--small"]]: size === Header.SIZES.SMALL,
      [styles["header--medium"]]: size === Header.SIZES.MEDIUM,
      [styles["header--large"]]: size === Header.SIZES.LARGE,
      [styles["header--extra-large"]]: size === Header.SIZES.EXTRA_LARGE,
      [styles["header--mega"]]: size === Header.SIZES.MEGA,
      [styles["header--thick"]]:
        thick &&
        size !== Header.SIZES.EXTRA_LARGE &&
        size !== Header.SIZES.LARGE,
      [styles["header--h1"]]: size === Header.SIZES.HEADING_ONE,
      [styles["header--h2"]]: size === Header.SIZES.HEADING_TWO,
      [styles["header--h3"]]: size === Header.SIZES.HEADING_THREE,
      [styles["header--h4"]]: size === Header.SIZES.HEADING_FOUR,
      [styles["header--h5"]]: size === Header.SIZES.HEADING_FIVE,
      [styles["header--h6"]]: size === Header.SIZES.HEADING_SIX,
    },
    className
  );
  return (
    <HeaderTag {...props} className={classNames}>
      {children}
    </HeaderTag>
  );
}

Header.SIZES = {
  HEADING_ONE: "h1",
  HEADING_TWO: "h2",
  HEADING_THREE: "h3",
  HEADING_FOUR: "h4",
  HEADING_FIVE: "h5",
  HEADING_SIX: "h6",
  MEGA: "mega",
  EXTRA_LARGE: "extraLarge",
  LARGE: "large",
  MEDIUM: "medium",
  SMALL: "small",
  EXTRA_SMALL: "extraSmall",
};

export default Header;
